import React, { useState, Fragment, useRef } from 'react';
import {
  Paper,
  Typography,
  Button,
  makeStyles,
  Dialog,
  DialogContent,
  IconButton,
  Grid,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { Video, Loader} from '../../../components';
import axios from 'axios';

const useStyles = makeStyles((theme) => ({
  banner: {
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    borderRadius: theme.spacing(1),
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
  },
  title: {
    fontSize: '18px',
    fontWeight: 'bold',
    marginBottom: theme.spacing(2),
  },
  button: {
    backgroundColor: 'transparent',
    color: theme.palette.secondary.main,
    padding: theme.spacing(1, 2),
    textDecoration: 'none',
    fontWeight: 'bold',
    borderRadius: theme.spacing(1),
    transition: 'background-color 0.3s, color 0.3s',
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      color: '#fff',
    },
    '&:not(:hover)': {
      backgroundColor: '#fff',
      color: theme.palette.secondary.main,
    },
  },
  quantityPopup: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(4),
  },
  quantitySelector: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between', // Changed to horizontal layout
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    width: '120px', // Ensure full width
  },
  quantityNumber: {
    fontSize: '18px',
    fontWeight: 'bold',
  },
  costCounter: {
    fontSize: '18px',
  },
  videoContainer: {
    height: '200px', // Maintain aspect ratio
    width: 'calc(100% + 80px)',
    marginLeft:'0px',
    marginTop:'-20px',
    marginBottom: theme.spacing(2),
  },
}));

const UpsellBanner = (props) => {
  const classes = useStyles();
  const [isQuantityDialogOpen, setQuantityDialogOpen] = useState(false);
  const [quantity, setQuantity] = useState();
  const packageCost =(props.current_subscription!=undefined && props.current_subscription.subscription_interval=='YEAR')?'400':'40'; // Cost per package
  const creditsPerPackage = 1000; // Credits per package
  const [totalCost, setTotalCost] = useState(packageCost);
  const [totalCredits, setTotalCredits] = useState(creditsPerPackage);
  const [totalUsers, setTotalUsers] = useState(quantity);
  const [preview_data, setPreviewData] = useState();
  const [loader, setLoader]=useState(false);
  const handleQuantityChange = (value) => {
    if (value >= 0) {
      setQuantity(value);
      setTotalCost(packageCost * value);
      setTotalCredits(creditsPerPackage * value);
      setTotalUsers(value);
    }
  };
  let first_time=useRef(true);
  if(first_time.current==true){first_time.current=false; handleQuantityChange((props.active_subscription!=undefined)?props.active_subscription.minimum_quantity:0);}

  const handleSave = () => {
    setLoader(true);
    axios.post('/api/subscriptions/minimumQuantityUpdate', {minimum_quantity:quantity, type:(preview_data!=undefined)?'confirm':'preview'}).then((response) => {
      if(preview_data!=undefined){window.location.reload();}else{
        setLoader(false);
      setPreviewData(response.data);
    }
  })
  };

  console.log('PROPSPROPS', props);
  let unit_cost=undefined; if(props.current_subscription!=undefined){unit_cost=props.current_subscription.currency+packageCost;}

  let you_will_then_be=''; if(props.current_subscription!=undefined){you_will_then_be='Your base charge will now be '+props.current_subscription.currency+packageCost*quantity+' a '+props.current_subscription.subscription_interval.toLowerCase();}

  return (
    <>
      <Paper className={classes.banner}>
        <Typography className={classes.title}>
          Add more credits to your subscription
        </Typography>
        <Button
          variant="contained"
          size="small"
          onClick={() => setQuantityDialogOpen(true)}
          className={classes.button}
        >
          Upgrade Now
        </Button>
      </Paper>
      <Dialog open={isQuantityDialogOpen} onClose={() =>{ setQuantityDialogOpen(false); setPreviewData(undefined); setLoader(false); first_time.current=true;}}>
        <DialogContent className={classes.quantityPopup}>
        {(loader!=false)?
          <div style={{height:'200px', width:'600px'}}><Loader loading embed/></div>
          :(preview_data!=undefined)?
          <div style={{height:'200px'}}>{
          (props.active_subscription!=undefined && props.active_subscription.free_trial==true)?<Typography>{you_will_then_be}{", but you won't be charged until the end of your free trial. "}</Typography>
          :(preview_data.amount=='none' || preview_data.amount<=0)?
          <Typography>{you_will_then_be}{' from the next billing date, provided you have '+quantity+' users or less.'}</Typography>
          :
          <Typography>{'You will be charged '+props.current_subscription.currency+preview_data.amount+' for the remainder of this billing period. '+you_will_then_be+'.'}</Typography>
        }</div>:
        <Fragment>
          <div className={classes.videoContainer}>
            <Video style={{ width:'100%', height: '100%' }} video={'MORE_SUBSCRIPTION_CREDITS'} autoplay />
          </div>
          <Typography  style={{width:'100%'}}>{"Each unit costs "+ unit_cost+" and includes 1xTeam and 1xPro"}</Typography>
          <Typography  style={{width:'100%'}}>Each unit includes 1000 monthly credits and 1 user login.</Typography>
          <div className={classes.quantitySelector}>
            <IconButton
              onClick={() => handleQuantityChange(quantity - 1)}
              disabled={quantity <= 0}
            >
              <RemoveIcon />
            </IconButton>
            <span className={classes.quantityNumber}>{quantity}</span>
            <IconButton onClick={() => handleQuantityChange(quantity + 1)}>
              <AddIcon />
            </IconButton>
          </div>
          <Grid container style={{marginBottom:'30px', width:'calc(100% + 60px)'}}>
            <Grid item xs={4}><Typography style={{textAlign:'center'}}><b>Base Cost:</b> {props.current_subscription.currency}{totalCost}</Typography></Grid>
            <Grid item xs={4}><Typography style={{textAlign:'center'}}><b>Credits:</b> {totalCredits}</Typography></Grid>
            <Grid item xs={4}><Typography style={{textAlign:'center'}}><b>Total Users:</b> {totalUsers}</Typography></Grid>
          </Grid></Fragment>
        }
          <Button onClick={handleSave} color="primary" variant="contained">
            Confirm
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default UpsellBanner;
